import React, { MouseEventHandler } from 'react';
import Separator from '@westwing/ui-kit/Separator';
import ActionButton from '@westwing/ui-kit/ActionButton';
import FloatingLabelInput, { Hint } from '@westwing/ui-kit/FloatingLabelInput';
import useForm from '@westwing/ui-kit/Tools/hooks/useForm';
import {
    StyledHeader,
    StyledModalTitle,
    StyledForm,
    StyledModalContent,
    StyledFieldset,
    StyledModalParagraph,
    StyledModalFormActions,
} from '../loginAndRegistration.style';
import { VALIDATE_HOOK } from '../loginAndRegistration.types';
import magicLinkSchema from './magicLink.schema';
import useTranslate from 'Hooks/useTranslate';

type MagicLinkFormValues = {
    email: string;
};

export type MagicLinkFormProps = {
    onSubmit: (values: MagicLinkFormValues) => void;
    onNewPassword: MouseEventHandler<HTMLButtonElement>;
};
const MagicLinkForm = ({ onSubmit: onFormSubmit, onNewPassword }: MagicLinkFormProps): JSX.Element => {
    const { t, tPlain } = useTranslate();
    const schema = magicLinkSchema(tPlain);
    const { values, errors, onBlur, onSubmit, onChange, touched, isValidated } = useForm<MagicLinkFormValues>({
        schema,
        onSubmitValid: onFormSubmit,
        initialValues: {
            email: '',
        },
        validateOn: [VALIDATE_HOOK.BLUR, VALIDATE_HOOK.SUBMIT],
    });

    const title = t('Password forgotten? No problem!');
    const submit = t('Receive a login-link via mail');
    const emailLabel = tPlain('E-Mail');
    const description = t('Please enter the email address you used when you registered to Westwing.');
    const newPassword = t('Passwort zurücksetzen');
    const separator = t('or');

    const isEmailValid = () => {
        if (errors?.email) {
            return false;
        }
        if (touched.email || isValidated('email')) {
            return true;
        }
        return undefined;
    };
    return (
        <div>
            <StyledHeader>
                <StyledModalTitle>{title}</StyledModalTitle>
            </StyledHeader>
            <StyledModalContent>
                <StyledForm as="form" onSubmit={onSubmit} noValidate>
                    <StyledFieldset>
                        <StyledModalParagraph>{description}</StyledModalParagraph>
                        <FloatingLabelInput
                            label={emailLabel}
                            type="email"
                            name="email"
                            autoComplete="email"
                            value={values.email}
                            onChange={onChange}
                            onBlur={onBlur}
                            isValid={isEmailValid()}
                            hint={isEmailValid() === false && <Hint.Error as="output">{errors.email[0]}</Hint.Error>}
                        />

                        <StyledModalFormActions>
                            <ActionButton kind="primary" type="submit">
                                {submit}
                            </ActionButton>
                        </StyledModalFormActions>
                    </StyledFieldset>
                </StyledForm>
                <Separator>{separator}</Separator>
                <StyledModalFormActions>
                    <ActionButton kind="secondary" onClick={onNewPassword}>
                        {newPassword}
                    </ActionButton>
                </StyledModalFormActions>
            </StyledModalContent>
        </div>
    );
};
export default MagicLinkForm;
